export default __webpack_public_path__ + "static/media/Health-Care-Hospital.6bfa2c83.png";